import * as React from 'react';
import PropTypes from 'prop-types';

const SvgLogosFacebookXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M15.5 8.046C15.5 3.878 12.142.5 8 .5 3.858.5.5 3.878.5 8.046c0 3.766 2.743 6.888 6.328 7.454v-5.273H4.924V8.046h1.904V6.383c0-1.89 1.12-2.935 2.833-2.935.82 0 1.679.147 1.679.147v1.857h-.946c-.932 0-1.222.582-1.222 1.178v1.416h2.08l-.333 2.181H9.172V15.5c3.585-.566 6.328-3.688 6.328-7.454z"
        fill=""
      />
    </svg>
  )
);
SvgLogosFacebookXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgLogosFacebookXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgLogosFacebookXsmall;
